export const SET_PROCESSING_MODAL = "SET_PROCESSING_MODAL";
export const PROCESS_TYPE = "PROCESS_TYPE";
export const SET_MULTIPLE = "SET_MULTIPLE";

export default (state = { processingModal:false, processType: '' }, action: any)  => {
    switch (action.type) {
        case SET_PROCESSING_MODAL:
            const {processingModal} = action
            return {...state, processingModal};
        case PROCESS_TYPE:
            const {processType} = action
            return {...state, processType};
        case SET_MULTIPLE:
            return {...state, ...action.payload };
        default:
            return state
    }
};

export const setProcessingModal = (processingModal: boolean, processType: string) => (
    {
        type: SET_PROCESSING_MODAL, PROCESS_TYPE,
        processingModal, processType
    }
)
